export default "__VITE_ASSET__ChL2bd3a__"